
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm5.17 2.54a5.5 5.5 0 00-6.118 6.21H.06A4.5 4.5 0 017.01 7.764a2.8 2.8 0 015.16-1.724zm-.814-3.484a1.556 1.556 0 11-3.111 0 1.556 1.556 0 013.111 0z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.5-6.5a.5.5 0 00-1 0V11H9.5a.5.5 0 000 1H11v1.5a.5.5 0 001 0V12h1.5a.5.5 0 000-1H12V9.5z","fill":"#fff"}})])
          )
        }
      }
    